<template src='./form-export.html'></template>

<script>
import Vue from 'vue'
import FileSaver from 'file-saver'

export default {
  props: ['formName', 'projectCode', 'phaseFormId', 'revision'],
  data () {
    return {
    }
  },
  methods: {
    generateReport (format) {
      this.load = true
      this.$http.get(Vue.$apiConfig.generateFormsGet.replace('{projectCode}', this.$route.params.projectCode) + '?phaseFormId=' + this.phaseFormId + '&revision=' + this.revision + '&format=' + format, { responseType: 'arraybuffer' })
        .then(
          (response) => {
            var headers = response.headers
            var fileName = this.projectCode + ' - ' + this.formName + ' - ревизија - ' + this.revision
            var blob = new Blob([response.data], {
              type: headers.get('content-type')
            })
            FileSaver.saveAs(blob, fileName)
            this.load = false
          },
          (error) => {
            this.logConsole(error)
            this.notifyError(
              this.$t('apiStatusCodes.' + error.body.status.code)
            )
            this.load = false
          }
        )
    }
  }
}
</script>
